import { useEstablishmentUpdate } from '@sugg-gestion/ubidreams-react-suggpro'
import BookingView from 'components/views/booking/bookingView'
import { useApiErrors } from 'core/services/suggPro/useApiErrors'
import React from 'react'
import withAuthenticateLayout, { WithAuthenticateLayout } from '../hoc/withAuthenticateLayout'
import { WithGraphApiProps } from '../hoc/withGraphApi'
import withMuiPickersUtilsProvider from '../hoc/withMuiPickersUtilsProvider'
import BookingData from './bookingData'

interface Props extends WithAuthenticateLayout, WithGraphApiProps {}

const Booking: React.FC<Props> = ({ establishment, isGraphApiAuthenticated }) => {
    const { updateEstablishment, inProgress: bookingInProgress } = useEstablishmentUpdate()
    const { displayError } = useApiErrors()

    const handleFullDayUpdate = (days: Array<string>) => {
        updateEstablishment({
            id: establishment.id,
            establishment: {
                bookingFullDays: days,
            },
        }).catch((error) => displayError(error))
    }

    return (
        <>
            <BookingView
                businessHours={establishment.businessHours}
                fullDays={establishment.bookingFullDays ?? []}
                onFullDayUpdate={handleFullDayUpdate}
                bookingInProgress={bookingInProgress}
                specialClosing={establishment.specialClosing}
            >
                <BookingData isGraphApiAuthenticated={isGraphApiAuthenticated} id={establishment.id} />
            </BookingView>
        </>
    )
}

export default withMuiPickersUtilsProvider(withAuthenticateLayout(Booking))
